'use strict';

var cov_xiodyvevf = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\title.js',
      hash = '16fee33bb4098d9ebc71ca2230912f658ec4179e',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\title.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 6,
          column: 7
        }
      },
      '1': {
        start: {
          line: 5,
          column: 6
        },
        end: {
          line: 5,
          column: 39
        }
      },
      '2': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 30
        }
      },
      '3': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 12,
          column: 6
        }
      },
      '4': {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 11,
          column: 9
        }
      },
      '5': {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 48
        }
      },
      '6': {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 16,
          column: 6
        }
      },
      '7': {
        start: {
          line: 14,
          column: 19
        },
        end: {
          line: 14,
          column: 23
        }
      },
      '8': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 48
        }
      },
      '9': {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 21,
          column: 6
        }
      },
      '10': {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 20,
          column: 9
        }
      },
      '11': {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 48
        }
      },
      '12': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 45
        }
      },
      '13': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 28,
          column: 8
        }
      },
      '14': {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 27,
          column: 11
        }
      },
      '15': {
        start: {
          line: 26,
          column: 10
        },
        end: {
          line: 26,
          column: 32
        }
      },
      '16': {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 42,
          column: 6
        }
      },
      '17': {
        start: {
          line: 32,
          column: 22
        },
        end: {
          line: 32,
          column: 28
        }
      },
      '18': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 41,
          column: 7
        }
      },
      '19': {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 31
        }
      },
      '20': {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 24
        }
      },
      '21': {
        start: {
          line: 45,
          column: 0
        },
        end: {
          line: 50,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 3
          }
        },
        loc: {
          start: {
            line: 3,
            column: 118
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 4,
            column: 48
          },
          end: {
            line: 4,
            column: 49
          }
        },
        loc: {
          start: {
            line: 4,
            column: 59
          },
          end: {
            line: 6,
            column: 5
          }
        },
        line: 4
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 8,
            column: 20
          },
          end: {
            line: 8,
            column: 21
          }
        },
        loc: {
          start: {
            line: 8,
            column: 41
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 8
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 9,
            column: 55
          },
          end: {
            line: 9,
            column: 56
          }
        },
        loc: {
          start: {
            line: 9,
            column: 66
          },
          end: {
            line: 11,
            column: 7
          }
        },
        line: 9
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 13,
            column: 23
          },
          end: {
            line: 13,
            column: 24
          }
        },
        loc: {
          start: {
            line: 13,
            column: 37
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 13
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 17,
            column: 17
          },
          end: {
            line: 17,
            column: 18
          }
        },
        loc: {
          start: {
            line: 17,
            column: 29
          },
          end: {
            line: 21,
            column: 5
          }
        },
        line: 17
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 18,
            column: 39
          },
          end: {
            line: 18,
            column: 40
          }
        },
        loc: {
          start: {
            line: 18,
            column: 50
          },
          end: {
            line: 20,
            column: 7
          }
        },
        line: 18
      },
      '7': {
        name: 'buildToggler',
        decl: {
          start: {
            line: 23,
            column: 13
          },
          end: {
            line: 23,
            column: 25
          }
        },
        loc: {
          start: {
            line: 23,
            column: 39
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 23
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 24,
            column: 13
          },
          end: {
            line: 24,
            column: 14
          }
        },
        loc: {
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 28,
            column: 7
          }
        },
        line: 24
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 25,
            column: 46
          },
          end: {
            line: 25,
            column: 47
          }
        },
        loc: {
          start: {
            line: 25,
            column: 56
          },
          end: {
            line: 27,
            column: 9
          }
        },
        line: 25
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 31,
            column: 24
          },
          end: {
            line: 31,
            column: 25
          }
        },
        loc: {
          start: {
            line: 31,
            column: 36
          },
          end: {
            line: 42,
            column: 5
          }
        },
        line: 31
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }],
        line: 33
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainController =
/** @ngInject */
function MainController($scope, moment, $http, apiOpen, $rootScope, $window, $anchorScroll, $location, myVars, $mdSidenav, $log) {
  _classCallCheck(this, MainController);

  cov_xiodyvevf.f[0]++;
  cov_xiodyvevf.s[0]++;

  $http.get(apiOpen + 'categories/list').then(function (results) {
    cov_xiodyvevf.f[1]++;
    cov_xiodyvevf.s[1]++;

    $scope.categories = results.data;
  });
  cov_xiodyvevf.s[2]++;
  $scope.checkinfo = myVars;
  cov_xiodyvevf.s[3]++;
  $scope.dangky = function (packageid) {
    cov_xiodyvevf.f[2]++;
    cov_xiodyvevf.s[4]++;

    $http.post(apiOpen + 'dangky/' + packageid).then(function (results) {
      cov_xiodyvevf.f[3]++;
      cov_xiodyvevf.s[5]++;

      $window.location = results.data.message;
    });
  };
  cov_xiodyvevf.s[6]++;
  $scope.showLogin = function (ev) {
    cov_xiodyvevf.f[4]++;

    var data = (cov_xiodyvevf.s[7]++, true);
    cov_xiodyvevf.s[8]++;
    $rootScope.$emit('CallLogin', { ev: ev, data: data });
  };
  cov_xiodyvevf.s[9]++;
  $scope.huy = function () {
    cov_xiodyvevf.f[5]++;
    cov_xiodyvevf.s[10]++;

    $http.post(apiOpen + 'huy').then(function (results) {
      cov_xiodyvevf.f[6]++;
      cov_xiodyvevf.s[11]++;

      $window.location = results.data.message;
    });
  };
  cov_xiodyvevf.s[12]++;
  $scope.toggleLeft = buildToggler('left');
  function buildToggler(componentId) {
    cov_xiodyvevf.f[7]++;
    cov_xiodyvevf.s[13]++;

    return function () {
      cov_xiodyvevf.f[8]++;
      cov_xiodyvevf.s[14]++;

      $mdSidenav(componentId).toggle().then(function () {
        cov_xiodyvevf.f[9]++;
        cov_xiodyvevf.s[15]++;

        $log.debug('toggled');
      });
    };
  }

  cov_xiodyvevf.s[16]++;
  $scope.gotoAnchor = function () {
    cov_xiodyvevf.f[10]++;

    var newHash = (cov_xiodyvevf.s[17]++, 'body');
    cov_xiodyvevf.s[18]++;
    if ($location.hash() !== newHash) {
      cov_xiodyvevf.b[0][0]++;
      cov_xiodyvevf.s[19]++;

      // set the $location.hash to `newHash` and
      // $anchorScroll will automatically scroll to it
      $location.hash('body');
    } else {
      cov_xiodyvevf.b[0][1]++;
      cov_xiodyvevf.s[20]++;

      // call $anchorScroll() explicitly,
      // since $location.hash hasn't changed
      $anchorScroll();
    }
  };
};

cov_xiodyvevf.s[21]++;

angular.module('app').component('fountainTitle', {
  templateUrl: 'app/title.html',
  controller: MainController
});